
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useApplicationStatus = () => {
  return useQuery({
    queryKey: ['applicationStatus'],
    queryFn: async () => {
      try {
        // Check if user is authenticated
        const { data: { user }, error: userError } = await supabase.auth.getUser();
        if (userError || !user) {
          throw new Error('User not authenticated');
        }

        // Fetch the most recent application for this user
        const { data, error } = await supabase
          .from('applications')
          .select('id, status, progress')
          .eq('user_id', user.id)
          .order('updated_at', { ascending: false })
          .limit(1)
          .single();

        if (error) {
          console.error('Error fetching application status:', error);
          throw error;
        }

        return data || { id: null, status: 'draft', progress: 0 };
      } catch (error) {
        console.error('Application status error:', error);
        return { id: null, status: 'draft', progress: 0 };
      }
    },
    retry: 1,
    staleTime: 30000, // 30 seconds
  });
};
